import React, { useCallback, useMemo } from "react";
import classNames from "classnames";

import { IconButton, Typography } from "@mui/material";
import styles from "./Style.module.css";
import DataTables from "../../../../Datatables/Datatable.table";
import Constants from "../../../../config/constants";
import capitalizeFirstLetter from "../../../../hooks/CommonFunction";
import ShadowBox from "../../../../components/ShadowBox/ShadowBox";
import useUserListHook from "./UserList.hook";
import useRoles from "../../../../hooks/RoleHook";
import { ListActionComponent } from '../../../../components/CustomListHeader/CustomListHeader';


const UsersList = ({data, handleDetail}) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    currentData,
    currentPage,
  } = useUserListHook({data});
  const { canRead} = useRoles(Constants.MODULES.DASHBOARD);

  const renderFirstCell = useCallback((user) => {
    return (
      <div className={styles.firstCellFlex}>
        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div className={styles.fontBold}>{`${capitalizeFirstLetter(user?.full_name)}`} </div>
          <div>{`+${capitalizeFirstLetter(user?.full_contact)}`} </div>
          <div> {user?.employee_id}</div>
        </div>
      </div>
    );
  }, []);


  const tableStructure = useMemo(
    () => [
      {
        key: "user",
        label: "User Info",
        sortable: false,
        render: (value, all) => <div>{renderFirstCell(all?.user)}</div>,
      },

      {
        key: "program",
        label: "Program Name",
        sortable: false,
        render: (temp, all) => (
          <div>{capitalizeFirstLetter(all?.program?.name)}</div>
        ),
      },
      // {
      //   key: "client_name",
      //   label: "Client Name",
      //   sortable: false,
      //   render: (temp, all) => <div>{capitalizeFirstLetter(all?.client?.name)}</div>,
      // },
      {
        key: "total_earned",
        label: "Reward Points",
        sortable: false,
        render: (temp, all) => <div>{all?.total_earned}</div>,
      },
    //    ...(canRead ? [
    //   {
    //     key: "user_id",
    //     label: "Action",
    //     render: (temp, all) => (
    //       <div className={styles.actionButton}>
    //         {canRead &&   <ListActionComponent
    //           allData={all}
    //           handleDetail={handleDetail}
    //           key={all?.id}
    //         />}
    //       </div>
    //     ),
    //   },
    // ] : [])
    ],
    [handleDetail, renderFirstCell]
  );
  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
      // clickableRow: handleEditSidePannel,
    };
    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]);
  
  return (
    <div className={styles.wrapper}>
      <ShadowBox className={styles.w100}>
        <div className={styles.headerContainer}>
          <Typography
            variant={"title"}
            color={"text.primary"}
            className={styles.title}
          >
            Top Users
          </Typography>
        </div>
        <div>
          <div>
            <br />
            <div className={styles.w100}>
              <DataTables
                width="100%"
                {...tableData.datatable}
                {...tableData.datatableFunctions}
                hidePagination={true}
              />
            </div>
          </div>
        </div>
      </ShadowBox>
    </div>
  );
};

export default UsersList;
